import useSWR from 'swr';
import { useSnackbar } from 'notistack';
import { useContext } from 'react';
import { FixtureComparisonRating } from '@/service/types';
import { useAuthToken } from '@/contexts/auth/useAuthToken';
import { ScoringContext } from '@/contexts/scoring/context';
import {
  fetchFromMTService,
  SERVICE_ENDPOINT,
} from '../fetcher/monitoringToolService';
import { ApiError } from '../ApiError';
import { HTTP_STATUS_CODE } from '../constants';

export const useScoringRate = () => {
  const token = useAuthToken();
  const {
    state: { fixtureSummary },
  } = useContext(ScoringContext);

  const { enqueueSnackbar } = useSnackbar();
  const { data, error, mutate } = useSWR<FixtureComparisonRating[], ApiError>(
    token && fixtureSummary?.collectionId
      ? {
          token,
          endpoint: SERVICE_ENDPOINT.Collections(fixtureSummary.collectionId)
            .scoringRate.GET,
        }
      : null,
    fetchFromMTService,
    {
      onErrorRetry: (e, _, config, revalidate, { retryCount }) => {
        if (
          e.status !== HTTP_STATUS_CODE.NOT_FOUND &&
          e.status !== HTTP_STATUS_CODE.UNAUTHORIZED
        ) {
          return enqueueSnackbar(e.title, { variant: 'error' });
        }
        if (e.status === HTTP_STATUS_CODE.NOT_FOUND) return;
        if (e.status === HTTP_STATUS_CODE.UNAUTHORIZED) return;
        setTimeout(() => revalidate({ retryCount }), config.errorRetryInterval);
      },
      revalidateOnFocus: false,
    },
  );

  return {
    comparisonRating: data,
    error,
    isLoading: !data && !error,
    mutate,
  };
};
